import { Button, ButtonBase, styled as muiStyled } from '@mui/material'

export const MentorLegalPageContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  max-width: 768px;
  margin: 30px auto 0 auto;
  padding: 0px 15px;
`,
)

export const MentorLegalNoAgreements = muiStyled('div')(
  ({ theme }) => `
    font-size: 18px;
`,
)

export const MentorLegalListItem = muiStyled(ButtonBase)(
  ({ theme, accepted }) => `
    display: grid;
    grid-template-columns: 3fr 1fr 1fr;
    padding: 10px 20px;
    gap: 20px;
    box-shadow: 0 0 5px 0 ${accepted ? '#00000082' : '#A864FF'};
    border-radius: 5px;
    ${!accepted ? '1px solid #a864ff73;' : ''}
    width: 100%;
    :hover {
        background: #e9e9e9;
    };
    transition: all 90ms ease-in-out;
    @media(min-width: 768px) {
        grid-template-columns: 3fr 1fr 1fr 1fr;
    }
`,
)

export const MentorLegalListItemTitle = muiStyled('div')(
  ({ theme }) => `
    justify-self: self-start;
    font-weight: 500;
    font-size: 14px;
    @media(min-width: 768px){
        font-size: 16px;

    }
`,
)

export const AcceptNowContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  @media(min-width: 768px){
      font-size: 16px;
  }
`,
)

export const AcceptedNotAcceptedContainer = muiStyled('div')(
  ({ theme, accepted }) => `
  display:none;
    color: ${accepted ? 'inherit' : '#ff3131'};
    font-size: 14px;
    @media(min-width: 768px){
    display:block;
        font-size: 16px;
    }
`,
)

export const LegalPolicyFormContainer = muiStyled('form')(
  ({ theme }) => `
display: flex;
flex-direction: column;
align-items: center;
flex-grow: 1;
padding: 15px 30px;
gap: 10px;
@media(min-width:768px){
    padding: 20px 60px;
}
@media(min-width:992px){
    padding: 20px 60px;
}
`,
)

export const LegalPolicyHeadingContainer = muiStyled('div')(
  ({ theme }) => `
display: flex;
flex-direction: column;
align-items: center;
gap: 5px;
`,
)

export const LegalPolicyHeading = muiStyled('div')(
  ({ theme }) => `
font-size: 30px;
font-weight: 500;
@media(min-width: 768px){
font-size: 35px;
}
`,
)

export const LegalPolicyFields = muiStyled('div')(
  ({ theme }) => `
 display: flex;
 justify-content: center;
 align-items: center;
 flex-direction: column;
 gap: 20px;
 padding-top: 15px;
 @media(min-width: 768px){
     min-width: 550px;
 flex-direction: row;
 gap: 275px;
 }
 @media(min-width: 992px){
     min-width: 650px;
 flex-direction: row;
 gap: 340px;
 }
`,
)

export const LegalPolicyArticleContainer = muiStyled('div')(
  ({ theme }) => `
    padding: 40px 0px 20px;
    width: 100%;
    @media(min-width: 768px){
    padding: 50px 0px;
    }
`,
)

export const AgreeTermsButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    background: #A864FF;
    color: #fff;
    padding: 7px 40px;
    border-radius: 30px;
    &:disabled {
    background: #c5c5c5;
    }
    transition: all 100ms linear;
`,
)

export const HeadingFields = muiStyled('div')(
  ({ theme, notAccepted }) => `
    color: ${notAccepted ? 'red' : 'inherit'};
    font-size: 16px;
`,
)

export const HeadingFieldDiv = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`,
)

export const PolicyPageNavHeader = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding:0px 0px 20px;
`,
)

export const PolicyFormPageBackButton = muiStyled(Button)(
  ({ theme }) => `
    text-transform:none;
    font-size: 17px;
    color:#2c2c2c;
    &:hover {
          background-color: rgba(78,78,78,0.4);
    }
`,
)

export const LegalAgreementsListingTabsContainer = muiStyled('div')(
  ({ theme }) => `
    width: 100%;
    display:flex;
    justify-content:flex-start;
`,
)

export const LegalAgreementsTabButton = muiStyled(ButtonBase)`
    padding: 10px 25px;
    background: green;
    border-radius: 7px;
    background: #4f4f4f;
    color: white;
`

export const LegalAgreementUserFields = muiStyled('div')(
  ({ theme }) => `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap:5px;
  padding: 30px 0px 20px 0px;
`,
)
export const LegalAgreementUserFieldTitle = muiStyled('span')(
  ({ theme }) => `
  font-weight: 500;
`,
)

export const LegalAgreementLoadingContainer = muiStyled('div')(
  ({ theme }) => `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`,
)

export const LegalAgreementsListingContainer = muiStyled('div')(
  ({ theme }) => `
    width: 100%;
`,
)
